export default __webpack_public_path__ + "static/media/logo-azul.08e067d6.png";